import request from '@/utils/request';

// 设备报表
export const getDeviceStatistics = (params: any) =>
  request({
    url: 'DeviceStatistics/getDevice',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportDeviceStatistics = (params: any) =>
  request({
    url: 'DeviceStatistics/export',
    method: 'get',
    params
  });
